import angular from 'angular';

export default angular.module('shared').component('asuiForm', {
    template: require('./asuiForm.component.html'),
    controller: [asuiFormComponent],
    bindToController: true,
    bindings: {
        subject: '<',
        items: '<',
        onSubmit: '&',
        submitButtonText: '<'
    }
});

function asuiFormComponent() {
    var vm = this;
    vm.$onInit = init;
    function init() {
        vm.submitButtonText = vm.submitButtonText || 'Submit';
    }

    vm.submit = () => {
        if (vm.onSubmit) {
            vm.onSubmit();
        }
    };
}



// WEBPACK FOOTER //
// ./modules/shared/components/asui-form/asuiForm.component.js